module.exports = __webpack_public_path__ + "media/images/icons/outlined/dot-chart-3c19796f6c86ee90c3001d519cedaa7e.svg";